module.exports = __webpack_public_path__ + "ee1983dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/insta_icon.png
// module id = 1924
// module chunks = 18 19 31 32 36